import * as RewardsEvents from "@/analytics/events/rewards"
import { useShare } from "@/hooks/useShare"
import { useRewardsProgramData, useUser } from "@/queries/user"
import { useMemo } from "react"
import { createBranchReferralLink } from "@/stores/branch"

export const useRefer = (tab: "rewards" | "earning points") => {
  const share = useShare()
  const { data: user } = useUser()

  const referralLink = useMemo<string | undefined>(() => {
    return user?.me ? createBranchReferralLink({ user: user.me }) : undefined
  }, [user])

  return () => {
    RewardsEvents.referAFriendClicked({
      currentTab: tab,
      pointBalance: user?.me?.lastPointTransaction?.balance || 0,
    })

    void share({
      message: `Try Backflip to easily customize and filter through comps, plus get access to fast financing for your flips!

You'll unlock 0.15% savings on origination fees for your first loan by joining with my referral link:
`,
      url: referralLink,
      title: "Try Backflip to analyze properties and unlock savings",
      subject: "Try Backflip to analyze properties and unlock savings",
    })
  }
}

export const useCurrentTier = () => {
  const { data: rewardsProgramData } = useRewardsProgramData()

  const { data: user } = useUser()
  const balance = user?.me?.lastPointTransaction?.balance || 0

  if (balance === 0) {
    return {
      currentTier: undefined,
      nextTier: rewardsProgramData?.tiers?.[0],
    }
  }

  if (
    balance >=
    rewardsProgramData?.tiers![rewardsProgramData.tiers!.length - 1]
      ?.minPointsRequired!
  ) {
    return {
      currentTier:
        rewardsProgramData?.tiers![rewardsProgramData.tiers!.length - 1],
      nextTier: undefined,
    }
  }

  const nextTierIndex = rewardsProgramData?.tiers?.findIndex(
    (tier) => (tier?.minPointsRequired || 0) > balance
  )
  const currentTier =
    (nextTierIndex || 0) > 0
      ? rewardsProgramData?.tiers![nextTierIndex! - 1]
      : undefined

  return {
    currentTier,
    nextTier: rewardsProgramData?.tiers![nextTierIndex || 0],
  }
}
